import React, { useEffect, useState } from "react";
import InboxTable from "./InboxTable";
import { OBPSService } from "../../../../../../../libraries/src/services/elements/OBPS";
import { Loader, Toast } from "@egovernments/digit-ui-react-components";
import FilterForm from "./FilterForm";
import { convertDateToEpoch } from "@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date";
import { useTranslation } from "react-i18next";
import { getRevenueDetails } from "./helper/revenueFormHelper";

function RevenueDetail({ setApiData, apiData }) {
  const userInfo = Digit.UserService.getUser();
  const authToken = Digit.UserService.getUser()?.access_token || null;
  let tenantId = Digit.ULBService.getCurrentTenantId();

  let userType = userInfo?.info?.roles?.some((role) => role.code === "SUPERUSER" || role.code === "EMPLOYEE_ADMIN")
    ? "SuperAdmin"
    : userInfo?.info?.roles?.some((role) => role.code === "HRMS_ADMIN")
    ? "Admin"
    : null;
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const location1 = userDetails?.location1?.length > 1 ? userDetails?.location1?.concat(" Development Authority") : null;

  const { t } = useTranslation();
  if (userType) {
    tenantId = Digit.ULBService.getStateId();
  }
  const [isLoading, setIsLoading] = useState(true);
  const [showToast, setShowToast] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState("");

  const fetchData = async (tenantId, params = null) => {
    setShowToast(null);

    try {
      const result = await getRevenueDetails(authToken, userInfo?.info, tenantId, setIsLoading, params, location1);

      if (!result) {
        throw new Error("No data received from server");
      } else if (result?.length === 0) {
        setShowToast({
          key: "true",
          warning: true,
          message: "No Records Found",
        });
      }
      setApiData(result);
    } catch (err) {
      console.error("Error fetching data:", err);
      // handle API error message if available
      const message = err?.response?.data?.message || err?.message || "Something went wrong while fetching data";
      setShowToast({
        key: "true",
        error: true,
        message: message,
      });
      setApiData(null);
    }
  };
  const closeToast = () => {
    setShowToast(null);
  };

  const handleFormSubmit = async (formData) => {
    let { createdFrom, createdTo, developmentAuthorityName } = formData;

    setSelectedLocation(formData?.developmentAuthorityName);

    try {
      await fetchData(tenantId, formData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchDataOnMount = async () => {
      await fetchData(tenantId, null);
    };
    fetchDataOnMount();
  }, [tenantId]);

  return (
    <div>
      <FilterForm
        onSubmit={handleFormSubmit}
        userDetails={userDetails}
        userType={userType}
        location1={location1}
        onReset={() => {
          fetchData(tenantId, null);
          setSelectedLocation("");
        }}
      />
      {isLoading && (
        <div>
          <Loader />
        </div>
      )}
      {!isLoading && showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}

      {!isLoading && !showToast && apiData && <InboxTable apiData={apiData} tenantId={tenantId} location={location1 || selectedLocation} />}
    </div>
  );
}

export default RevenueDetail;
